// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__1-5dN","ModalOpen":"Modal_ModalOpen__xRwYI","openModal":"Modal_openModal__3-agV","ModalClose":"Modal_ModalClose__3Cav6","closeModal":"Modal_closeModal__qvf7m"};